import {
  AppBar,
  Backdrop,
  Box,
  CircularProgress,
  FormControl,
  Grid,
  List,
  ListItem,
  ListItemButton,
  Paper,
  Stack,
  TextField,
  Typography,
  Snackbar,
  Table,
  TableContainer,
  TableBody,
  TableRow,
  TableCell,
  IconButton,
} from "@mui/material";
import React, { useEffect, useState } from "react";
//import { SelectChangeEvent } from "@mui/material/Select";
import axiosBaseURL from "../../../utilities/httpCommon";
import Pagination from "@mui/material/Pagination";
import usePagination from "../../../utilities/Pagination";
//import process = require("process");
import CheckoutDialog from "./CheckoutDialog";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import OfficeAddinMessageBar from "./OfficeAddinMessageBar";
import { GetLockdetails } from "../../../utilities/Wordutil";

/* global console Word localStorage */
//axios.defaults.baseURL = process.env.REACT_APP_API_KEY;

const Checkout = () => {
  const [templatedata, settemplatedata] = useState([]);
  const [orglistvalues, setorglistvalues] = useState([]);
  const [isprogress, setprogress] = useState(false);
  //const [seltype, setSeltype] = React.useState("");
  const [selectedIndex, setSelectedIndex] = React.useState(0);
  const [searchValue, setSearchValue] = useState("");
  const [page, setPage] = React.useState(1);
  const [opendlg, setOpendlg] = React.useState(false);
  const [seltemplateId, setseltemplateId] = useState("");
  const [seltemplateName, settemplateName] = useState("");
  const [seltemplateVer, settemplateVer] = useState("");
  const [erroropen, seterroropen] = useState(false);
  const [errMsgd, seterrMsgd] = useState("");
  const PER_PAGE = 60;
  const count = Math.ceil(templatedata.length / PER_PAGE);
  const _DATA = usePagination(templatedata, PER_PAGE);

  const ShowItemDialog = (Selitem: any) => {
    setseltemplateId(Selitem.id);
    settemplateName(Selitem.name);
    settemplateVer(Selitem.version);
    setOpendlg(true);
  };

  const handleerrorClose = () => {
    seterroropen(false);
  };

  const errorDismissed = () => {
    seterrMsgd("");
  };

  const handleClosedlg = (newValue?: any) => {
    setOpendlg(false);
    if (newValue != null) {
      OpenSelectedTemplate(newValue);
    }
  };

  // const handleSelectChange = (event: SelectChangeEvent) => {
  //   const filterval = event.target.value as string;
  //   setSeltype(filterval);
  //   if (filterval === "All") {
  //     settemplatedata(orglistvalues);
  //   } else {
  //     let filterlst = orglistvalues.filter(function (obj) {
  //       return obj.type === filterval;
  //     });
  //     settemplatedata(filterlst);
  //   }
  // };

  const handleChange = (_event: React.ChangeEvent<unknown>, value: number) => {
    setPage(value);
    _DATA.jump(value);
  };

  // const fetchData = async () => {
  //   try {
  //     setprogress(true);
  //     const res = await axios.get("/getmetadata?object=Template__c", {
  //       withCredentials: true,
  //     });
  //     setprogress(false);
  //     if (res.data != null) {
  //       console.log(res.data.fields);
  //       res.data.fields.forEach((field) => {
  //         if (field.picklistValues.length > 0) {
  //           if (field.name == "Type__c") {
  //             settypelist(field.picklistValues);
  //             setSeltype("All");
  //           }
  //         }
  //       });
  //     }
  //   } catch (err) {
  //     console.log(err.message);
  //   }
  // };

  async function OpenSelectedTemplate(doccontent: any) {
    try {
      if (doccontent != null) {
        setprogress(true);
        console.log("doccontent");
        console.log(doccontent);
        let checklockedId = await GetLockdetails(doccontent.id);
        var blnDoLock = true;
        let loginUsrid = localStorage.getItem("sfuserid");
        if (checklockedId.id != "NA") {
          blnDoLock = false;
        }
        var result = await QueryData(
          "SELECT Id, LinkedEntityId, ContentDocumentId FROM ContentDocumentLink where LinkedEntityId = '" +
            doccontent.id +
            "'",
          false
        );
        if (result != null && Array.isArray(result)) {
          var docs = await QueryData(
            "SELECT Id, ContentDocumentId, Title, ContentModifiedDate, VersionData FROM ContentVersion where ContentDocumentId = '" +
              result[0].ContentDocumentId +
              "'",
            false
          );
          if (docs != null && Array.isArray(docs)) {
            let filename = docs[0].Title;
            let doc64data = await QueryData(docs[0].VersionData, true);
            console.log("doc64data");
            console.log(doc64data);
            if (doc64data.data != null) {
              await Word.run(async function (context) {
                var myNewDoc = context.application.createDocument(doc64data.data);
                context.load(myNewDoc);
                await context.sync();
                myNewDoc.properties.customProperties.add("Template Ver", doccontent.id);
                await context.sync();
                myNewDoc.save(Word.SaveBehavior.save, filename);
                await context.sync();
                context.load(myNewDoc);
                await context.sync();
                myNewDoc.open();
                await context.sync();

                //Whether read-only or not
                if (checklockedId.id != "NA") {
                  myNewDoc.properties.customProperties.add("LockedBy", checklockedId.id);
                  await context.sync();
                  myNewDoc.properties.customProperties.add("LockedName", checklockedId.name);
                  await context.sync();
                  myNewDoc.properties.customProperties.add("LockedType", checklockedId.type);
                  await context.sync();
                  if (checklockedId.id != loginUsrid) {
                    myNewDoc.properties.customProperties.add("IsRead", "true");
                  }
                }
                //Ends here

                //Add code to set document link
                var reqdata = {
                  Id: doccontent.id,
                  IsLocked__c: true,
                  Locked_By__c: localStorage.getItem("sfuserid"),
                  Locked_Date__c: new Date().toISOString(),
                  Type: doccontent.type,
                };
                console.log("Request data");
                console.log(reqdata);
                if (blnDoLock) {
                  await axiosBaseURL
                    .post("/sfserver/CreateDocumentLock", reqdata, {
                      withCredentials: true,
                    })
                    .then(async () => {
                      myNewDoc.properties.customProperties.add("Locked ID", doccontent.id);
                    })
                    .catch((error) => {
                      setprogress(false);
                      if (error.response) {
                        seterrMsgd(error.response.data);
                      } else if (error.request) {
                        seterrMsgd(error.request);
                      } else {
                        seterrMsgd(error.message);
                      }
                    });
                } else {
                  myNewDoc.properties.customProperties.add("Locked ID", doccontent.id);
                }
                await context.sync();
                //Ends here
              }).catch(function (myError) {
                console.log(myError.message);
                seterroropen(true);
              });
            }
          }
        }
        setprogress(false);
      }
    } catch (err) {
      console.log("Error");
      console.log(err);
    }
  }

  const QueryData = async (soqlquery: string, childrelation: boolean) => {
    try {
      setprogress(true);
      const res = await axiosBaseURL
        .get("/sfserver/query?q=" + soqlquery, {
          withCredentials: true,
        })
        .catch((error) => {
          setprogress(false);
          if (error.response) {
            seterrMsgd(error.response.data);
          } else if (error.request) {
            seterrMsgd(error.request);
          } else {
            seterrMsgd(error.message);
          }
        });
      setprogress(false);
      console.log(res.data);
      if (res.data != null) {
        if (!childrelation) return res.data.records;
        else if (childrelation) return res.data;
      } else return null;
    } catch (err) {
      setprogress(false);
    }
  };

  async function GetTemplateObject() {
    setprogress(true);
    let result = await QueryData("SELECT Id, Name, Description__c, Type__c, Version_Number__c FROM Template__c", false);
    setprogress(false);
    if (result != null) {
      let arrrefs = [];
      result.forEach((record) => {
        arrrefs.push({
          id: record.Id,
          name: record.Name,
          description: record.Description__c,
          type: record.Type__c,
          version: record.Version_Number__c,
        });
      });
      arrrefs.sort((a, b) => a.name.localeCompare(b.name));
      settemplatedata(arrrefs);
      setorglistvalues(arrrefs);
      setSelectedIndex(-1);
    }
  }

  useEffect(() => {
    GetTemplateObject();
  }, []);
  useEffect(() => {
    const newlistvalues = orglistvalues.filter((value) => value.name.toLowerCase().includes(searchValue.toLowerCase()));
    settemplatedata(newlistvalues);
  }, [searchValue]);

  return (
    <Box sx={{ p: 1, marginTop: 0, marginLeft: 0, marginRight: 0 }}>
      {errMsgd.length > 0 ? <OfficeAddinMessageBar onDismiss={errorDismissed} message={errMsgd + " "} /> : null}
      <Grid container>
        {/* <Grid item xs={12} sx={{ marginTop: 1 }}>
          <FormControl fullWidth>
            <InputLabel id="typelabel">Filter by type</InputLabel>
            <Select
              size="small"
              sx={{ padding: 0 }}
              labelId="typelabel"
              defaultValue="All"
              name="type"
              label="Filter by type"
              value={seltype}
              onChange={handleSelectChange}
            >
              <MenuItem key="All" value="All">
                All
              </MenuItem>
              {typelist.map((picklst) => (
                <MenuItem key={picklst.label} value={picklst.value}>
                  {picklst.value}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid> */}
        <Grid item xs={12} sx={{ marginTop: 1 }}>
          <FormControl fullWidth size="small" sx={{ minWidth: 260, padding: 0 }}>
            <TextField
              name="searchfield"
              label="Search template by name"
              size="small"
              variant="outlined"
              onChange={(e) => setSearchValue(e.target.value)}
              value={searchValue}
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} sx={{ marginTop: 1 }}>
          <Box>
            <Paper elevation={0} sx={{ border: 1, borderColor: "lightgray", overflow: "auto" }}>
              <List dense disablePadding sx={{ padding: 0 }}>
                {_DATA.currentData().map((item, index) => (
                  <ListItem sx={{ margin: "0 px", padding: "0 px" }} divider disablePadding={true} key={index}>
                    <ListItemButton
                      key={index}
                      selected={selectedIndex === index}
                      onClick={() => {
                        setSelectedIndex(index);
                      }}
                      sx={{ padding: 0, pl: 2 }}
                    >
                      <Box>
                        <TableContainer sx={{ padding: 0 }}>
                          <Table
                            size="medium"
                            aria-label="a dense table"
                            sx={{ padding: 0, width: "100%" }}
                            onClick={() => ShowItemDialog(item)}
                          >
                            <TableBody>
                              <TableRow
                                component="th"
                                scope="row"
                                sx={{ "td, th": { border: 0, padding: 0, margin: 0 } }}
                              >
                                <TableCell
                                  sx={{
                                    minWidth: 245,
                                    margin: "auto",
                                    textAlign: "left",
                                    fontWeight: "semibold",
                                    color: "#1C39BB",
                                  }}
                                >
                                  {item.name}
                                </TableCell>
                                <TableCell>
                                  <IconButton onClick={() => ShowItemDialog(item)}>
                                    <KeyboardArrowRightIcon />
                                  </IconButton>
                                </TableCell>
                              </TableRow>
                              <TableRow
                                component="th"
                                scope="row"
                                sx={{ "td, th": { border: 0, padding: 0, margin: 0 } }}
                              >
                                <TableCell colSpan={2}>{item.description}</TableCell>
                              </TableRow>
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </Box>
                    </ListItemButton>
                  </ListItem>
                ))}
              </List>
            </Paper>
          </Box>
        </Grid>
        <Grid item>
          <AppBar position="fixed" sx={{ top: "auto", bottom: 0, bgcolor: "white" }}>
            <Stack direction="row" justifyContent="flex-end">
              <Typography sx={{ fontSize: 14, marginTop: 0.5, color: "#1C39BB" }}>Page: {page}</Typography>
              <Pagination count={count} page={page} onChange={handleChange} />
            </Stack>
          </AppBar>
        </Grid>
      </Grid>
      <CheckoutDialog
        open={opendlg}
        onClose={handleClosedlg}
        agreementId={seltemplateId}
        agreementNumber={seltemplateName}
        agreementVersion={seltemplateVer}
      />
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        open={erroropen}
        onClose={handleerrorClose}
        message="This document has already opened, please close and try open again."
        key="errorsnack"
      />
      <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={isprogress}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </Box>
  );
};

export default Checkout;
